import EmployeeModel from './employee.model';

export default class EmployeeListModel {
  employees: EmployeeModel[];

  constructor(data: EmployeeListModel) {
    this.employees = data?.employees || [];
  }
}
